import {
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import {animate, style, transition, trigger} from '@angular/animations';
import {
  CollaborationConversationListComponentName,
  FieldConversationComponentName
} from "../../store/collaboration.constants";

@Component({
    standalone: false,
    selector: 'particle-field-conversation',
  templateUrl: './field-conversation.component.html',
  styleUrls: ['./field-conversation.component.scss'],
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({opacity: '0'}),
        animate('.5s ease-out', style({opacity: '1'}))
      ])
    ])
  ]
})
export class FieldConversationComponent implements OnInit, OnDestroy {
  collaborationConversationListComponentName: string;
  conversationComponentName: string;
  constructor() {
    this.collaborationConversationListComponentName = CollaborationConversationListComponentName;
    this.conversationComponentName = FieldConversationComponentName;
  }

  ngOnInit() {
  }


  ngOnDestroy() {
  }

}
